import { render, staticRenderFns } from "./PercentageChangeChip.vue?vue&type=template&id=57a84c6e"
import script from "./PercentageChangeChip.vue?vue&type=script&lang=js"
export * from "./PercentageChangeChip.vue?vue&type=script&lang=js"
import style0 from "./PercentageChangeChip.vue?vue&type=style&index=0&id=57a84c6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports